module.exports = __webpack_public_path__ + "static/media/GoL-ClearGlass-Logo.5704db32.png";